<template>
    <!-- Gleicher Rahmen wie die Nachbar-Box (Ausstehende Freigaben), damit die
         beiden Blöcke auf der Übersicht als Paar wirken. -->
    <div
        class="border border-4 border-minplan-beige p-2 md:p-6 mt-6 w-full flex flex-col"
    >
        <div class="flex items-baseline justify-between gap-3">
            <h2 class="font-bold uppercase tracking-wider">
                {{ $t("apartments.notes") }}
            </h2>
            <Link
                v-if="notesLink && entries.length > 3"
                :href="notesLink"
                class="text-xs text-minplan-darkbeige hover:text-minplan-blue"
            >
                {{ $t("apartments.showAllNotes") }} ({{ entries.length }}) &rarr;
            </Link>
        </div>

        <!-- Anriss: immer die drei neuesten Einträge -->
        <div v-if="entries.length" class="mt-4 divide-y divide-minplan-lightwhite">
            <Link
                v-for="entry in entries.slice(0, 3)"
                :key="entry.uuid"
                :href="notesLink"
                class="flex items-center justify-between gap-4 py-2.5 px-2 -mx-2 hover:bg-minplan-lightwhite"
            >
                <span class="flex items-center gap-2 min-w-0">
                    <component
                        :is="iconFor(entry.category)"
                        class="h-4 w-4 shrink-0 text-minplan-darkbeige"
                    />
                    <span class="text-sm text-minplan-blue truncate">{{
                        entry.title
                    }}</span>
                </span>
                <span
                    class="flex items-center gap-1.5 text-xs text-minplan-darkbeige whitespace-nowrap"
                >
                    <!-- Entscheid 13: der Block ist eng — hier steht das
                         SYMBOL, nicht das Wort «für Käufer», sonst verdrängt
                         das Kennzeichen den Titel. Der Wortlaut reist als
                         `title`/`aria-label` mit, damit er für Maus und
                         Screenreader erreichbar bleibt. -->
                    <span
                        v-if="entry.visibleForBuyer"
                        class="shrink-0 text-minplan-blue"
                        :title="$t('apartments.noteVisibleBadge')"
                        :aria-label="$t('apartments.noteVisibleBadge')"
                    >
                        <EyeIcon class="h-3.5 w-3.5" />
                    </span>
                    {{ entry.dateFormatted }}
                </span>
            </Link>
        </div>

        <p v-else class="py-4 text-sm text-minplan-darkgreybeige">
            {{ $t("apartments.emptyNote") }}
        </p>

        <div v-if="notesLink" class="flex justify-end items-end mt-auto pt-4">
            <!-- ?neu=1 öffnet das Formular auf der Notizen-Seite sofort — ein
                 Klick statt zwei. -->
            <primary-button @click="$inertia.visit(notesLink + '?neu=1')">
                <PencilAltIcon class="-ml-1 mr-2 h-5 w-5 text-minplan-darkgreybeige" />
                {{ $t("apartments.newNote") }}
            </primary-button>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import { PencilAltIcon, EyeIcon } from "@heroicons/vue/outline";
import { noteIconFor } from "@/Shared/noteIcons";
import PrimaryButton from "@/Jetstream/PrimaryButton";

export default defineComponent({
    props: ["apartment", "notes", "notesLink"],
    components: {
        Link,
        PencilAltIcon,
        EyeIcon,
        PrimaryButton,
    },
    computed: {
        entries() {
            return this.notes || [];
        },
    },
    methods: {
        iconFor(category) {
            return noteIconFor(category);
        },
    },
});
</script>

<style scoped></style>
